import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import TaxPayer from "../../models/tax-payer";
import TaxPayerExtraGrantsForm from "./TaxPayerExtraGrantsForm";

interface TaxPayerExtraGrantsModalProps {
  show: boolean;
  taxPayer?: TaxPayer;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TaxPayerExtraGrantsModal: React.FC<TaxPayerExtraGrantsModalProps> = ({
  show,
  taxPayer,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = taxPayer
    ? `Concesiones extras — ${taxPayer.socialName}`
    : "Concesiones extras";

  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <TaxPayerExtraGrantsForm
              taxPayer={taxPayer}
              onCancel={onCancel}
              onSuccess={onSuccess}
            />
          ) : null}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerExtraGrantsModal;
